import type { ConfigSection, GameProfile, ProfileCtx } from "./types";

const configSections: ConfigSection[] = [
  { component: "ConfSection", props: { name: "basic" } },
  { component: "ConfSection", props: { name: "extended" } },
];

export default (_ctx: ProfileCtx): Partial<GameProfile> => ({
  configSections,
});
